import { LogoPackage } from './LogoPackage';

export const PageLoader = () => {
    return (
        <div className="page_loader" role="status" aria-live="polite" aria-label="Loading">
            <div className="page_loader__glow page_loader__glow--top" />
            <div className="page_loader__glow page_loader__glow--bottom" />

            <div className="page_loader__content">
                <div className="page_loader__logo">
                    <LogoPackage />
                </div>

                <div className="page_loader__progress" aria-hidden="true">
                    <span className="page_loader__progress__bar" />
                </div>

                <p className="page_loader__label">Loading your experience</p>
            </div>
        </div>
    );
};